import { UserDetailI } from './user-management.interfaces';
import { AuthRole } from '../../../auth';
import * as moment from 'moment';
import { AccountState } from './user-management.enums';

export class UserDetail implements UserDetailI {
    account_state: AccountState;
    city = null;
    address = '';
    plan_start_time: string;
    role: AuthRole;
    client_id = null;
    country = null;
    created_at = null;
    dob = null;
    email = null;
    full_name = null;
    is_active: true
    login_source = null;
    login_type = null;
    pan = null;
    phone = null;
    photo = null;
    plan = null;
    state = null;
    brokers = [];
    plan_id: number;
    extra_credit = 0;
    is_algo_provider = false;
    insufficient_balance: boolean;
    previous_plan_id: number;

    // Model Fields
    plan_start_moment: moment.Moment;
    account_validity_moment: moment.Moment;

    constructor(details: UserDetailI) {
        this.updateFields(details);
    }

    updateFields(details: UserDetailI) {
        Object.keys(details).forEach(key => {
            this[key] = details[key];
        });

        this.plan_start_moment = moment(details.plan_start_time);
        this.account_validity_moment = moment(this.plan_start_moment).add(this.extra_credit, 'days');
    }
}
